module.exports = __webpack_public_path__ + "img/driver.9f9aa75e.png";